import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import { useTheme } from '../../../contexts/ThemeContext';

export default function RsHelpTip({ id, text }) {
  const { colors } = useTheme();
  if (!text) return null;
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id={id}>{text}</Tooltip>}>
      <button
        type="button"
        data-testid={id}
        aria-label={text}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 22,
          height: 22,
          margin: 0,
          padding: 0,
          border: 'none',
          borderRadius: 6,
          background: 'transparent',
          color: colors.textMuted,
          cursor: 'help',
          flexShrink: 0,
        }}
      >
        <QuestionCircle size={14} />
      </button>
    </OverlayTrigger>
  );
}
